import {
  POST_WORKFLOW,
  RESET_BOOKING_WORKFLOW,
  GET_WORKFLOW_HISTORY,
} from '@redturtle/volto-io-prenoto/actions/workflow';

const initialState = {
  loading: false,
  loaded: false,
  result: {},
  error: null,
};

// Get Day busy slots
export const workflow = (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET_BOOKING_WORKFLOW:
      return {
        ...state,
        result: null,
        loading: false,
        loaded: false,
      };
    case `${POST_WORKFLOW}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${POST_WORKFLOW}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${POST_WORKFLOW}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const workflowHistory = (state = { subrequests: {} }, action = {}) => {
  switch (action.type) {
    case `${GET_WORKFLOW_HISTORY}_PENDING`:
      return {
        ...state,
        subrequests: {
          ...state.subrequests,
          [action.subrequest]: {
            ...(state.subrequests[action.subrequest] || {}),
            error: null,
            loaded: false,
            loading: true,
          },
        },
      };

    case `${GET_WORKFLOW_HISTORY}_SUCCESS`:
      return {
        ...state,
        subrequests: {
          ...state.subrequests,
          [action.subrequest]: {
            result: { ...action.result },
            error: null,
            loaded: true,
            loading: false,
          },
        },
      };

    case `${GET_WORKFLOW_HISTORY}_FAIL`:
      return {
        ...state,
        subrequests: {
          ...state.subrequests,
          [action.subrequest]: {
            result: { ...action.result },
            error: action.error,
            loaded: false,
            loading: false,
          },
        },
      };
    default:
      return state;
  }
};
